<template>
  <div class="sc-bubble">
    <div class="flex-row-1 align-center">
      <div class="flex-row-1">
        <img
          alt="Category"
          :src="getImage()"
          class="sc-phone-item"
        >
        <div class="sc-phone-container">
          <span class="sc-phone-title">{{ title }}</span>
          <span class="sc-phone-subtitle">{{ sub }}</span>
        </div>
      </div>
      <img
        src="@shared/assets/img/general/chevron-right-white.svg"
        class="sc-arrow-img"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCategoryItem',
  props: {
    title: String,
    sub: String,
    imageSrc: String,
  },
  methods: {
    getImage() {
      return require(`@shared/assets/img/partner-detail/${this.imageSrc}.png`);
    },
  },
};
</script>

<style lang="scss">
.sc-bubble {
  background-color: #2B3757;
  width: 100%;
  height: 52px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 10px;

  &:not(:first-child) {
    margin-top: 4px;
  }

  .sc-phone-item {
    height: 32px;
  }

  .sc-phone-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-left: 8px;

    .sc-phone-title {
      font-size: 0.75rem;
      font-weight: bold;
      color: white;
    }

    .sc-phone-subtitle {
      font-size: 0.6rem;
      ;
      color: white;
    }
  }

  .sc-arrow-img {
    height: 7px;
  }
}
</style>
